/**
 * Strips functions and non-JSON values so drawer props can be persisted and later passed back to openDrawer.
 */
export const sanitizeDrawerPropsForUserActionsHistory = (
  props: Record<string, unknown>,
): Record<string, unknown> | undefined => {
  try {
    const json = JSON.stringify(props, (_k, v) => {
      if (typeof v === "function") {
        return undefined;
      }
      return v;
    });
    if (!json || json === "{}") {
      return undefined;
    }
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return undefined;
  }
};
